import {
  useEntityMetadataIncludeExternal,
  useFormBaseMetadata,
  useModuleFederationContext,
  useTranslation,
} from '@msdk/common'
import { EntityMetadata, EntityModel, FormMode } from '@msdk/definitions'
import { FormPage, ImportedComponentErrorBoundary, resolveItem } from '@msdk/forms'
import { PageInformation } from '@msdk/functional-components'
import { COLORS, styled } from '@msdk/ui'
import { useLocation, useParams, useSearchParams } from 'react-router-dom'

const ContentWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== '$mode' && prop !== '$centered',
})<{
  $mode: string
  $centered: boolean | undefined
}>`
  display: flex;
  flex: 1;
  overflow: auto;

  background-color: ${(props) => {
    if (props.$centered) {
      if (props.$mode == 'Readonly') {
        return COLORS.white.main
      }
      return COLORS.grey50
    } else {
      return COLORS.white.main
    }
  }};
`

export default function Form() {
  const { entityName, moduleName, id } = useParams()
  const { pathname, search } = useLocation()

  const [query] = useSearchParams()
  const mode: FormMode = (query.get('mode') as FormMode) ?? 'Edit'

  const model = useEntityMetadataIncludeExternal(entityName as string, moduleName) as EntityModel
  const formModel = model.getForm(moduleName as string)
  const baseMetadata = useFormBaseMetadata(entityName as string, moduleName as string) as EntityMetadata
  const modules = useModuleFederationContext()
  const msModule = modules.loadedModules[baseMetadata.msProvider]
  const ImportedComponent = resolveItem(msModule, formModel?.componentDefinition?.fullName)

  const t = useTranslation()

  return (
    <ContentWrapper $mode={mode} $centered={formModel?.isCentered()}>
      <PageInformation pageTitle={t(formModel!.idml, formModel!.description)} />
      {ImportedComponent && (
        <ImportedComponentErrorBoundary>
          <ImportedComponent />
        </ImportedComponentErrorBoundary>
      )}
      {!ImportedComponent && (
        //the key is here to avoid strange behaviour when switching from readonly and edit on the same form
        <FormPage
          key={pathname + search}
          entityName={entityName as string}
          formName={moduleName as string}
          id={id as string}
          mode={mode}
        />
      )}
    </ContentWrapper>
  )
}
